<template>
  <div class="min-h-screen bg-stone-50 font-kanit text-ink">
    <router-view />
    <GlobalToast />
  </div>
</template>

<script setup>
import GlobalToast from "./components/GlobalToast.vue";
</script>
